import React, {Component} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';
import './main.css';
import Request from '../request';
import {IMAGE_URL} from '../constants';
import ReactHtmlParser from 'react-html-parser';

class Main extends Component {
    state = {
        images: [],
        isMobile: this.props.isMobile
    };

    componentWillMount(){
        Request.get("slider")
            .then(response=>{
                if(response.status === "error"){ console.log(response.data);}
                let images = [];
                response.data.map((item, index)=>{
                   images.push({
                       url: item.image,
                       url2: item.image2,
                       content_tr: item.content_tr,
                       content_eng: item.content_eng
                   });
                   return true;
                });
                this.setState({images});
            })
            .catch(e => console.log(e));
    }

    componentWillReceiveProps(props) {
        if(props.isMobile === this.state.isMobile) return false;
        this.setState({isMobile: props.isMobile});
    }

    render() {
        //console.log(this.state.isMobile, this.state.images);
        return <>
        {!this.state.isMobile &&
            <div className="main">
                <Carousel className="slider" showThumbs={false} showStatus={false} autoPlay interval={5000} transitionTime={1000} infiniteLoop axis="horizontal">
                    {this.state.images.length > 0 &&
                    this.state.images.map((item, index) => {
                        let url = IMAGE_URL + item.url;
                        return (<div key={index}><img alt="" src={url}/>
                            {this.props.lang === "tr" && <div className="legend">{ReactHtmlParser(item.content_tr)}</div>}
                            {this.props.lang === "eng" && <div className="legend">{ReactHtmlParser(item.content_eng)}</div>}
                        </div>);
                    })
                    }
                </Carousel>
            </div>
        }
        {this.state.isMobile &&
            <div className="main mainMobile">
                <Carousel className="slider" showThumbs={false} showStatus={false} autoPlay interval={5000} transitionTime={1000} infiniteLoop axis="horizontal">
                    {this.state.images.length > 0 &&
                    this.state.images.map((item, index) => {
                        let url2 = IMAGE_URL + item.url2;
                        return (<div key={index}><img alt="" src={url2}/>
                            {this.props.lang === "tr" && <div className="legend">{ReactHtmlParser(item.content_tr)}</div>}
                            {this.props.lang === "eng" && <div className="legend">{ReactHtmlParser(item.content_eng)}</div>}
                        </div>);
                    })
                    }
                </Carousel>
            </div>
        }

        </>;
    }
}

export default Main;